import { AuthContext } from "@/features/authentication/AuthContext";
import { useContext } from "react";

export function useAuthContext() {
    return useContext(AuthContext);
}
